var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 7.26074C8.66421 7.26074 9 7.59653 9 8.01074V11.5107C9 11.925 8.66421 12.2607 8.25 12.2607C7.83579 12.2607 7.5 11.925 7.5 11.5107V8.01074C7.5 7.59653 7.83579 7.26074 8.25 7.26074Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 2.00098C4.66015 2.00098 1.75 4.91113 1.75 8.50098C1.75 12.0908 4.66015 15.001 8.25 15.001C11.8399 15.001 14.75 12.0908 14.75 8.50098C14.75 4.91113 11.8399 2.00098 8.25 2.00098ZM0.25 8.50098C0.25 4.0827 3.83172 0.500977 8.25 0.500977C12.6683 0.500977 16.25 4.0827 16.25 8.50098C16.25 12.9193 12.6683 16.501 8.25 16.501C3.83172 16.501 0.25 12.9193 0.25 8.50098Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 4.75098C8.66421 4.75098 9 5.08676 9 5.50098V5.51098C9 5.92519 8.66421 6.26098 8.25 6.26098C7.83579 6.26098 7.5 5.92519 7.5 5.51098V5.50098C7.5 5.08676 7.83579 4.75098 8.25 4.75098Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.13e8b1fbc4ab2866564e58befb20c671.svg";
export { ForwardRef as ReactComponent };